import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState } from '../../models/session.models';


export const selectSessionState = createFeatureSelector<SessionState>('session');
export const selectSessionId = createSelector(selectSessionState, (state) => state.id);
export const selectSessionStarted = createSelector(selectSessionState, (state) => state.started);
export const selectSessionStarting = createSelector(selectSessionState, (state) => state.starting);
